import { useEffect, useMemo, useState } from 'react'

export function useMediaQuery(query: string): boolean {
  const media = useMemo(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return null
    }
    return window.matchMedia(query.replace('@media', '').trim())
  }, [query])
  const [matches, setMatches] = useState(media?.matches ?? false)

  useEffect(() => {
    if (!media) {
      return
    }

    setMatches(media.matches)

    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    if (media.addEventListener) {
      media.addEventListener('change', listener)
    } else {
      media.addListener(listener)
    }

    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener)
      } else {
        media.removeListener(listener)
      }
    }
  }, [media, setMatches])

  return matches
}
